import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Defer non-critical initialization
const initNonCritical = () => {
  // Load fonts optimized
  import('./utils/fontLoader').then(({ loadFontsOptimized }) => loadFontsOptimized());
  
  // Defer non-critical CSS loading
  import('./utils/cssLoader').then(({ deferNonCriticalCSS }) => deferNonCriticalCSS());
  
  // Initialize route preloading after app is interactive
  import('./utils/routePreloader').then(({ initializeRoutePreloading }) => initializeRoutePreloading());
  
  // Register Service Worker for asset caching (production only)
  if (import.meta.env.PROD) {
    import('./lib/serviceWorkerRegistration').then(({ registerServiceWorker }) => {
      registerServiceWorker();
    });
  }
  
  // Initialize Web Vitals tracking
  import('./lib/webVitals').then(({ initWebVitals }) => {
    initWebVitals();
  });
};

// Render app immediately - highest priority
createRoot(document.getElementById("root")!).render(<App />);

// Initialize non-critical features after render
if ('requestIdleCallback' in window) {
  requestIdleCallback(initNonCritical, { timeout: 2000 });
} else {
  setTimeout(initNonCritical, 50);
}
